import * as React from "react";

const FavIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    id="Filled"
    width="512"
    height="512"
    viewBox="0 0 24 24"
  >
    <path d="m1.327 12.4 3.56 2.6-1.352 4.187A3.18 3.18 0 0 0 4.719 22.8a3.18 3.18 0 0 0 3.8-.019L12 20.219l3.482 2.559a3.227 3.227 0 0 0 4.983-3.591L19.113 15l3.56-2.6a3.227 3.227 0 0 0-1.9-5.832H16.4l-1.327-4.136a3.227 3.227 0 0 0-6.146 0L7.6 6.568H3.231a3.227 3.227 0 0 0-1.9 5.832Z"></path>
  </svg>
);

export default FavIcon;
